module.exports = __webpack_public_path__ + "img/card5.d37fa848.jpg";